import gql from 'graphql-tag';

export default gql`
    query GetLoadInfo($input: GetLoadInfoInput) {
        getLoadInfo(input: $input) {
            loadId
            jobSummaryId
            weight
        }
    }
`;
